import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Pest.css";

import img1 from "../components/images/pest1.jpg";
import img2 from "../components/images/pest2.jpg";

import cockroach from "../components/images/cockroach.jpg";
import rodent from "../components/images/rodent.jpg";
import mosquito from "../components/images/mosquito.jpg";
import lizard from "../components/images/lizard.jpg";
import ants from "../components/images/ants.jpg";
import silverfish from "../components/images/silverfish.jpg";
import bedbugs from "../components/images/bedbugs.jpg";
import termites from "../components/images/termites.jpg";
import snakes from "../components/images/snakes.jpg";
import flies from "../components/images/flies.jpg";

import brand1 from "../components/images/brand1.jpg";
import brand2 from "../components/images/brand2.jpg";
import brand3 from "../components/images/brand3.jpg";
import brand4 from "../components/images/brand4.jpg";
import brand5 from "../components/images/brand5.jpg";
import brand6 from "../components/images/brand6.jpg";
import brand7 from "../components/images/brand7.jpg";



const Pest = () => {

  const images = [img1, img2];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    const interval = setInterval(() => {
      setIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const pests = [
    {
      img: cockroach,
      name: "Cockroaches",
      desc: "Fast spreading pests found in kitchens and storage areas."
    },
    {
      img: rodent,
      name: "Rodents",
      desc: "Effective rodent control for homes and workplaces."
    },
    {
      img: mosquito,
      name: "Mosquitoes",
      desc: "Protection against harmful mosquito bites and diseases."
    },
    {
      img: flies,
      name: "Flies",
      desc: "Effective fly control for hygienic indoor spaces."
    },
    {
      img: lizard,
      name: "Lizard",
      desc: "Safe removal solutions for indoor lizard problems."
    },
    {
      img: ants,
      name: "Ants",
      desc: "Long-term ant prevention and treatment solutions."
    },
    {
      img: silverfish,
      name: "Silverfish",
      desc: "Protect books, clothes and storage spaces from damage."
    },
    {
      img: bedbugs,
      name: "Bed Bugs",
      desc: "Advanced treatments for mattress and furniture infestations."
    },
    {
      img: termites,
      name: "Termites",
      desc: "Prevent structural damage with expert termite control."
    },
    {
      img: snakes,
      name: "Snakes",
      desc: "Professional snake handling and safe relocation services."
    }
  ];


  return (
    <div className="premium-pest-page">

      {/* INTRO SECTION */}

      <section
        className={`premium-intro-section slide-${index}`}
        style={{
          backgroundImage: `url(${images[index]})`
        }}
      >
        <div className="container">

          <div className="premium-intro-wrapper">

            {/* RIGHT CONTENT */}

            <div className="premium-intro-content">

              <h2>
                Smart & Reliable Pest Control For Modern Spaces
              </h2>

              <p>
                Out of sight doesn’t mean pests aren’t causing harm. From bed bugs and ants to cockroaches and rats, hidden pests can damage your home, business and even your health.

              </p>

              <p>
                TPC provides customized and effective pest control solutions to remove unwanted pests and prevent them from returning.
              </p>

              <div className="premium-feature-grid">

                <div className="premium-feature-box">
                  <h5>Safe Treatments</h5>
                  <p>Family & pet-friendly pest solutions.</p>
                </div>

                <div className="premium-feature-box">
                  <h5>Expert Team</h5>
                  <p>Trained professionals with modern techniques.</p>
                </div>

              </div>



            </div>

          </div>
          {/* DOTS */}

          <div className="premium-dots">

            {images.map((_, i) => (
              <span
                key={i}
                className={index === i ? "active-dot" : ""}
                onClick={() => setIndex(i)}
              ></span>
            ))}

          </div>

        </div>

      </section>

      {/* PESTS SECTION */}
      <section className="premium-pests-section">
        <div className="container">

          <div className="premium-heading text-center" data-aos="fade-up">


            <h2>— Pest We Control —</h2>
            <p>
              If you notice signs of pest activity, our expert team is ready to inspect and provide the right treatment solution quickly.
            </p>
          </div>

          <div className="row g-4 mt-2">

            {pests.map((item, i) => (
              <div className="col-lg-4 col-md-6" key={i} data-aos="zoom-in" data-aos-delay="0"
                data-aos-duration="700">

                <div className="premium-pest-card">

                  <div className="premium-pest-image-wrap">
                    <img src={item.img} alt="" className="premium-pest-image" />
                  </div>

                  <h5>{item.name}</h5>

                  <p>{item.desc}</p>

                </div>

              </div>
            ))}

          </div>
        </div>
      </section>


      {/* BRANDS */}
      <section className="premium-brands-section">
        <div className="container">

          <div className="premium-brands-heading text-center" data-aos="fade-up">

            <h2>— Brands Of Pesticides We Use —</h2>
          </div>

          <div className="row g-4 mt-3 justify-content-center">

            {[brand1, brand2, brand3, brand4, brand5, brand6, brand7].map((img, i) => (

              <div className="col-lg-3 col-md-4 col-6" key={i} data-aos="zoom-in" data-aos-delay="0"
                data-aos-duration="700">

                <div className="premium-brand-card">
                  <img src={img} alt="brand" className="premium-brand-img" />
                </div>

              </div>
            ))}

          </div>
        </div>
      </section>

    </div>
  );
};

export default Pest;




